import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TableColumn } from '../../../core/models/table-column';
import { TableColumnService } from '../../../core/interfaces/table/table-column.service';
import { Subscription } from 'rxjs';
import { ColumnSelectionListComponent } from '../column-selection-list/column-selection-list.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'app-column-selection',
  templateUrl: './column-selection.component.html',
  styleUrls: ['./column-selection.component.scss'],
})
export class ColumnSelectionComponent implements OnInit, OnDestroy {
  @Input() tableColumns: TableColumn[];
  @Input() service: TableColumnService;
  @Input() cssClass: string;
  @Input() disabled: boolean;
  private subscriptions: Subscription[] = [];
  private overlay: HTMLIonModalElement;

  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Show Overlay for Column Selection.
   */
  onClick() {
    if (this.disabled) return;

    const onCancel = new EventEmitter();
    const onSave = new EventEmitter<TableColumn[]>();

    this.subscriptions.push(
      this.modalService
        .showModalNew(
          ColumnSelectionListComponent,
          {
            columnsSelection: this.tableColumns,
            onCancel,
            onSave,
          },
          this.cssClass
        )
        .subscribe((element) => {
          this.overlay = element;
          this.overlay.animated = false;
          this.overlay.present();
        })
    );

    // exit on cancel
    this.subscriptions.push(
      onCancel.subscribe(() => {
        this.modalService.dismissModalNew(this.overlay);
        this.cleanUp();
      })
    );

    // exit on save
    this.subscriptions.push(
      onSave.subscribe((newSelection) => {
        this.modalService.dismissModalNew(this.overlay);
        this.service.showSelectedColumns(newSelection);
        this.cleanUp();
      })
    );
  }

  cleanUp() {
    this.overlay = null;
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }
}
